export default __webpack_public_path__ + "static/media/Pfeil_Hellblau_Nach_Unten_Boxen.41c2f184.svg";